export const LABEL_STYLE = "text-[var(--Neutral_grey-700,#344054)] font-noto text-[14px] font-medium leading-[24px]";
